import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { ProgressBar as Component } from './progress-bar';
import styles from './styles/styles.css';
import type { TProgressBar, IDeps } from './models';

export const ProgressBar = createWidget<IDeps, TProgressBar>(
    { styles },
    { priorityStyler: true }
)(Component);
